import React, { useRef, useEffect, useMemo, useState, useCallback } from 'react';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import { Gallery } from 'devextreme-react/gallery';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, SimpleItem, Label, ButtonItem, FormRef } from "devextreme-react/form";
import IEntreprise from '../../models/IEntreprise';
import IAnneeFiscale from '../../models/IAnneeFiscale';
import { FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar } from '../base';
import useCustomDataSource, { IFormBaseDataSourceOptions, Mode } from "../../hooks/useCustomDataSource";
import { useProvinces } from "../../components/selectbox";
import FormSysteme from '../../components/forms/form-systeme';
import { Button, FileUploader } from 'devextreme-react';
import useApi from '../../hooks/useApi';
import LabelTemplate from './LabelTemplate';
import useEnum from '../../hooks/useEnum';
import { useContextPopupPage } from '../../components/popups/PopupPage';

interface IGestionEntreprisesProps {
  isModeSelection?: boolean,
}

// TODO probleme de connexion SqlDbManisoftCentral
export default function GestionEntreprises({ isModeSelection }: IGestionEntreprisesProps) {
  const entrepriseFormDataSource = useCustomDataSource<IEntreprise, IEntreprise>({ path: "entreprise", primaryKey: "idEntreprise" });
  const { setMainForm, selectedDataRow: selectedEntreprise, setSelectedDataRow, mode, setMode, isFieldModifier, onFieldDataChanged } = entrepriseFormDataSource;
  const { getData } = useApi<object>();
  const formRef = useRef<FormRef>(null);
  const [img, setImg] = useState(['https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS1kDUlAoHSHMLsWevOP38tezszurHS2NIOAQuxPrmRA1CeL6FwnR8c3QOHbvNz56v48j0&usqp=CAU']);
  const { ProvinceSelectBox, currentProvince } = useProvinces();
  const { setSelectedValue } = useContextPopupPage();

  const anneeFiscaleDataSourceOptions = useMemo<IFormBaseDataSourceOptions>(() => {
    return { path: "anneeFiscale", primaryKey: "idAnneeFiscale" }
  }, [selectedEntreprise?.idEntreprise]);
  const anneeFiscaleDataSource = useCustomDataSource<IAnneeFiscale, IAnneeFiscale>(anneeFiscaleDataSourceOptions);
  const { editorOptions: typeEntrepriseEditorOptions } = useEnum(undefined, "gestionTypeEntreprise", '25%');

  const dataBases = ["Manisoft"];
  const phoneMask = "(NNN) NNN-NNNN";
  const phoneRules = { "N": /[0-9]/ };
  const zipCodeMask = "XNX NXN";
  const zipCodeRules = { "X": /[a-zA-Z]/, "N": /[0-9]/ };

  const phoneEditorOptions = useMemo(() => {
    return { mask: phoneMask, maskRules: phoneRules, maxLength: 13, width: 'max-content' }
  }, []);
  const zipCodeEditorOptions = useMemo(() => {
    return { mask: zipCodeMask, maskRules: zipCodeRules, maxLength: 6, width: '23%' }
  }, []);
  const maxLength100Options = useMemo(() => {
    return { maxLength: 100, width: '55%' };
  }, []);
  const maxLength60Options = useMemo(() => {
    return { maxLength: 60, width: '55%' };
  }, []);
  const noTpsOptions = useMemo(() => {
    return { maxLength: 20, width: '55%' };
  }, []);
  const baseDonneeOptions = useMemo(() => {
    return { items: dataBases, defaultValue: dataBases[0], width: "40%" };
  }, []);
  const codeCampingQuebecEditorOptions = useMemo(() => {
    return {
      maxLength: 5,
      width: '25%'
    };
  }, []);
  const noEtablissementEditorOptions = useMemo(() => {
    return {
      width: '25%',
      min: 0
    };
  }, []);
  const widthEditorOptions = useMemo(() => {
    return { width: '55%' };
  }, []);


  // const btnChangerOptions = useMemo(() => ({ onClick: () => { }, stylingMode: "text", disabled: false, icon: "find" } as dxButtonOptions), []);
  // const btnEnleverOptions = useMemo(() => {
  //   return {
  //     disabled: !isModeModifier,
  //     text: "Enlever",
  //     onClick: () => {
  //       setSelectedDataRow((prev: IEntreprise) => (
  //         { ...prev, logo: '' }
  //       ));
  //     }
  //   };
  // }, []);

  const changeEditorOptions = useMemo(() => {
    return {};
  }, []);

  const _loadBonsDeTravail = useCallback(async () => {
    // const result = await getData({ customPath: `entreprise/logo` });
    // console.log(result)
    // const resultArray = Object.values(result);
    // console.log(resultArray)
    // const result = await getData({ customPath: `client/${IDclient}/bonsTravailHistorique` });
    // setDataBonsDeTravail(result as any[]);
  }, [selectedEntreprise]);

  useEffect(() => {
    if (selectedEntreprise)
      _loadData();
    // _loadData(selectedEntreprise?.idClient)
  }, [selectedEntreprise, mode])

  const _loadData = useCallback(async () => {
    await Promise.all([
      _loadBonsDeTravail(),
    ]);
  }, [selectedEntreprise, _loadBonsDeTravail]);

  useEffect(() => {
    setMainForm(formRef.current?.instance());
  })

  useEffect(() => {
    if (mode !== Mode.Lecture) formRef.current?.instance().getEditor("nom")?.focus();
  }, [mode])
  // const dataSource = ['https://data:image/jpeg;base64,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']

  return (
    <FormListBase data={entrepriseFormDataSource}>
      <FormListBaseGrid dataSource={entrepriseFormDataSource.dataSource}
        onFocusedRowChanged={(e: any) => {
          if (mode === Mode.Modifier) setMode(Mode.Lecture);
          if (setSelectedValue && e.row?.data) {
            setSelectedValue(e.row.data);
          }
        }}>
        <Column key={"grid-col-nom"} dataField={"nom"} caption="Nom" allowHiding={false} />
        <Column key={"grid-col-description"} dataField={"description"} caption="Description" allowHiding={false} />
      </FormListBaseGrid>
      <FormListBaseToolbar removeBlocked={true} codeCampingQuebec={selectedEntreprise?.codeCampingQuebec} headerText={`${selectedEntreprise?.nom || ''}`} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} effacerOptions={{ visible: false, disabled: !isFieldModifier }} />
      {!isModeSelection || isModeSelection && mode !== Mode.Lecture
        ? <FormListBaseTab>
          <TabItem title="Informations">
            <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedEntreprise || {} as IEntreprise} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
              <GroupItem colCount={3}>

                <GroupItem colSpan={2}>
                  <SimpleItem key={"frm-nom"} dataField={"nom"} editorOptions={maxLength100Options} />
                  <SimpleItem key={"frm-adresse"} dataField={"adresse"}
                    editorOptions={maxLength100Options} />
                  <GroupItem colCount={2}>
                    <SimpleItem key={"frm-ville"} dataField={"ville"}
                      editorOptions={maxLength60Options} />
                    <SimpleItem key={"frm-code-postal"} dataField={"codePostal"} editorOptions={zipCodeEditorOptions}>
                      <Label text={"Code postal"} />
                    </SimpleItem>
                  </GroupItem>
                  <SimpleItem key={"frm-province"} dataField={"idProvince"} editorType={"dxSelectBox"} render={ProvinceSelectBox}>
                    <Label text='Province' />
                  </SimpleItem>
                  <SimpleItem key={"frm-courriel1"} dataField={"courriel1"} editorOptions={maxLength60Options}>
                    <Label text={"Courriel 1"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-courriel2"} dataField={"courriel2"} editorOptions={maxLength60Options}>
                    <Label text={"Courriel 2"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-description"} dataField={"description"} editorOptions={widthEditorOptions} />
                  <SimpleItem key={"frm-site-web"} dataField={"siteWeb"} editorOptions={widthEditorOptions}>
                    <Label text={"Site web"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-no-tps"} dataField={"noTps"} editorOptions={noTpsOptions}>
                    <Label text={"Numéro TPS"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-no-tvq"} dataField={"noTvq"}
                    editorOptions={noTpsOptions}>
                    <Label text={"Numéro TVQ"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-no-etablissement"} dataField={"noEtablissement"} editorType={"dxNumberBox"} editorOptions={noEtablissementEditorOptions}>
                    <Label text={"Numéro établissement"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-code-camping-quebec"} dataField={"codeCampingQuebec"} editorOptions={codeCampingQuebecEditorOptions}>
                    <Label text={"Code Camping Québec"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-type-entreprise"} dataField={"typeEntreprise"} editorType={"dxSelectBox"} editorOptions={typeEntrepriseEditorOptions}>
                    <Label text={"Type d'entreprise"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-base-donnee"} dataField={"baseDonnee"} editorType={"dxSelectBox"} editorOptions={baseDonneeOptions}>
                    <Label text={"Base de données"} />
                  </SimpleItem>
                  <SimpleItem>
                    <div style={{ marginTop: "1.3em" }}>
                      <label style={{ fontWeight: "bold" }}>Deuxième adresse</label>
                    </div>
                  </SimpleItem>
                  <SimpleItem key={"frm-adresse2"} dataField={"adresse2"}
                    editorOptions={maxLength100Options}>
                    <Label text={"Adresse 2"} />
                  </SimpleItem>
                  <GroupItem colCount={2}>
                    <SimpleItem key={"frm-ville2"} dataField={"ville2"}
                      editorOptions={maxLength60Options}>
                      <Label text={"Ville 2"} />
                    </SimpleItem>
                    <SimpleItem key={"frm-code-postal2"} dataField={"codePostal2"}
                      editorOptions={zipCodeEditorOptions}>
                      <Label text={"Code postal 2"} />
                    </SimpleItem>
                  </GroupItem>
                  <SimpleItem key={"frm-province2"} dataField={"idProvince2"} editorType={"dxSelectBox"} render={ProvinceSelectBox}>
                    <Label text={"Province 2"} />
                  </SimpleItem>
                </GroupItem>


                <GroupItem
                  colSpan={1}
                >
                  <GroupItem caption={"Contact"}>
                    <SimpleItem key={"frm-telephone1"} dataField={"telephone1"} editorOptions={phoneEditorOptions}>
                      <Label text={"Téléphone 1"} />
                      <Label render={LabelTemplate(selectedEntreprise.typeEntreprise)} />
                    </SimpleItem>
                    <SimpleItem key={"frm-telephone2"} dataField={"telephone2"} editorOptions={phoneEditorOptions}>
                      <Label text={"Téléphone 2"} />
                      <Label render={LabelTemplate(selectedEntreprise.typeEntreprise)} />
                    </SimpleItem>
                    <SimpleItem key={"frm-telephone3"} dataField={"telephone3"} editorOptions={phoneEditorOptions}>
                      <Label text={"Téléphone 3"} />
                      <Label render={LabelTemplate(selectedEntreprise.typeEntreprise)} />
                    </SimpleItem>
                    <SimpleItem key={"frm-fax"} dataField={"fax"} editorOptions={phoneEditorOptions} />
                  </GroupItem>


                  <GroupItem caption={"Logo d'entreprise"}>
                    <GroupItem colCount={2}>
                      <SimpleItem editorOptions={changeEditorOptions} cssClass='leftItem'>
                        <FileUploader
                          disabled={mode === Mode.Lecture}
                          style={{
                            position: 'relative',
                            float: 'left'
                          }}
                          onValueChange={async (e) => {
                            if (e?.[0]) {
                              // if (e.value?.[0]) {
                              const file = e[0];
                              const fr = new FileReader();
                              await fr.readAsDataURL(file);
                              fr.onload = () => {
                                if (fr.result) {
                                  const base64 = fr.result?.toString()?.split(',')[1];
                                  if (base64)
                                    setSelectedDataRow((prev: IEntreprise) => (
                                      { ...prev, logo: base64 }
                                    ));
                                }
                              };
                            } else {
                              alert("File not selected or browser incompatible.")
                            }
                          }}
                          showFileList={false}
                          selectButtonText="Changer..."
                          labelText="" accept="image/*" uploadMode="useForm"
                        />
                        {/* <ButtonItem
                    key={"frm-logo"}
                    buttonOptions={btnChangerOptions}
                    /> */}
                      </SimpleItem>
                      {/* <ButtonItem
                          key={"frm-btn-enlever"}
                          buttonOptions={btnEnleverOptions}
                        /> */}
                      <SimpleItem cssClass='leftItem'>
                        <Button
                          style={{
                            position: 'relative',
                            float: 'left'
                            // top: '14px',
                          }}
                          onClick={() => {
                            setSelectedDataRow((prev: IEntreprise) => (
                              { ...prev, logo: '' }
                            ));
                          }}
                          disabled={mode === Mode.Lecture}
                          text="Enlever"
                        />
                      </SimpleItem>
                    </GroupItem>
                    <GroupItem>
                      <Gallery
                        dataSource={selectedEntreprise?.logo && [`data:image/png;base64,${selectedEntreprise.logo}`]}
                        noDataText='Pas de données image'
                        width={450}
                        height={250}
                        showIndicator={false}
                        style={{
                          border: '1px solid #000000',
                          backgroundColor: 'rgb(253, 253, 253)'
                        }}
                      />
                    </GroupItem>
                  </GroupItem>
                </GroupItem>


              </GroupItem>

            </Form>

          </TabItem>
          <TabItem title="Année fiscale">
            <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedEntreprise || {} as IEntreprise} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
              <GroupItem>
                <DataGrid
                  showBorders={true}
                  allowColumnResizing={true}
                  dataSource={anneeFiscaleDataSource.dataSource}
                  focusedRowEnabled={true}
                  autoNavigateToFocusedRow={true}
                >
                  <Column caption={"Date début"} dataField={'dateDebut'} />
                  <Column caption={"Date fin"} dataField={'dateFin'} />
                  <Column caption={"Année fiscale reportée"} dataField={'anneeFiscaleReportee'} />
                </DataGrid>
              </GroupItem>
            </Form>
          </TabItem>
          <TabItem title="Système"><FormSysteme formData={selectedEntreprise || {} as IEntreprise} /></TabItem>
        </FormListBaseTab> : null}
    </FormListBase>
  );
}
